require('./civilResponsability.scss');
require('./civilResponsability.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@helpers
const { getFormattedString } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');

// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKInput } = require('commonsComponents/OKInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@constants
const { EURO_TEXT, THIRD_STEP } = require('constants/index');
const {
    COVERAGES,
    SPECIAL_COVERAGES_MODAL: {
        DOGS_INCLUSION, DOGS_INCLUSION_YES, DOGS_INCLUSION_NO, MIN, MAX, INTEGER_OR_EMPTY,
        CIVIL_RESPONSABILITY_OPTIONS
    }
} = require('../../../../insuranceConstants/insuranceRequestHome');
const poeditorPrefix = `insuranceRequestHomeCC-insuranceRequestHomeCC_specialCoveragesModal`;

class CivilResponsability extends React.Component {

    constructor(props) {
        super(props);

        this.handleNumberOfDogsBlur = this.handleNumberOfDogsBlur.bind(this);
        this.handleNumberOfDogsChange = this.handleNumberOfDogsChange.bind(this);
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    }

    getSelectedPlanUpperCase() {
        const { immInsuranceWizardStep3 } = this.props;

        return immInsuranceWizardStep3.get('insurancePlan').toUpperCase();
    }

    getCoverage(coverageId) {
        const { immInsuranceWizardStep3 } = this.props;

        const selectedPlan = this.getSelectedPlanUpperCase();

        return immInsuranceWizardStep3.getIn(['coveragePlanModal', selectedPlan, coverageId]);
    }

    getCoverageValue(coverageId) {
        const coverage = this.getCoverage(coverageId);
        const defaultValue = coverage.get('defaultValue');
        const currentValue = coverage.get('currentValue');

        return currentValue || defaultValue;
    }

    hasPropChanged(coverageId, newValue) {
        const coverage = this.getCoverage(coverageId);
        const defaultValue = coverage.get('defaultValue');

        return newValue ? defaultValue !== newValue : false;
    }

    restrictValue(value) {
        let amount = parseInt(value);

        if (amount <= MIN) {
            amount = MIN;
        }

        if (MAX && amount >= MAX) {
            amount = MAX;
        }

        return amount;
    }

    handleNumberOfDogsBlur(evt) {
        const value = evt.target.value;
        const restrictedValue = value ? this.restrictValue(value) : '';
        const hasPropChanged = this.hasPropChanged(COVERAGES.DANGEROUS_DOGS_NUMBER, restrictedValue);
        const plan = this.getSelectedPlanUpperCase();

        this.props.setData(THIRD_STEP, {
            coveragePlanModal: {
                [plan]: {
                    [COVERAGES.DANGEROUS_DOGS_NUMBER]: {
                        currentValue: restrictedValue,
                        hasChanged: hasPropChanged
                    }
                }
            }
        });
    }

    updateNumberOfDogsValue(value) {
        if (INTEGER_OR_EMPTY.test(value)) {
            const plan = this.getSelectedPlanUpperCase();

            this.props.setData(THIRD_STEP, {
                coveragePlanModal: {
                    [plan]: {
                        [COVERAGES.DANGEROUS_DOGS_NUMBER]: {
                            currentValue: value,
                            defaultValue: value,
                            hasChanged: true
                        }
                    }
                }
            });
        }
    }

    handleNumberOfDogsChange(evt) {
        const value = evt.target.value;
        this.updateNumberOfDogsValue(value);
    }

    handleRadioButtonChange(coverageId) {
        const { setData } = this.props;
        const plan = this.getSelectedPlanUpperCase();

        return value => {
            const hasPropChanged = this.hasPropChanged(coverageId, value);

            setData(THIRD_STEP, {
                coveragePlanModal: {
                    [plan]: {
                        [coverageId]: {
                            currentValue: value,
                            hasChanged: hasPropChanged
                        }
                    }
                }
            });

            if (coverageId === DOGS_INCLUSION && value === DOGS_INCLUSION_NO) {
                // Set the number of dogs to empty when NO option selected
                this.updateNumberOfDogsValue('');
            }
        }
    }

    buildTooltip() {
        return (
            <OKTooltip
                content={<FormattedText value={`${poeditorPrefix}CivilResponsabilityTooltipCC`} />}
                offset={[0, -15]}
            />
        );
    }

    formatCurrency(amount) {
        return getFormattedString({
            amount: amount,
            currency: EURO_TEXT,
            decimalsLength: 0
        });
    }

    buildCivilResponsabilityLimit() {
        const civilResponsabilityValue = this.getCoverageValue(COVERAGES.CIVIL_LIABILITY);

        return (
            <RadioButtonGroup
                className="civil-responsability__radio-group"
                idPrefix="civilResponsabilityRadioGroup"
                label={formatText(`${poeditorPrefix}CivilResponsabilityLimit`)}
                name="civilResponsabilityRadioGroup"
                onChange={this.handleRadioButtonChange(COVERAGES.CIVIL_LIABILITY)}
                selectedValue={civilResponsabilityValue}
            >
                {Object.keys(CIVIL_RESPONSABILITY_OPTIONS).map((key, index) => {
                    return (
                        <RadioButton
                            key={`civil-responsability-${index}`}
                            label={this.formatCurrency(CIVIL_RESPONSABILITY_OPTIONS[key].label)}
                            value={CIVIL_RESPONSABILITY_OPTIONS[key].value}
                        />
                    );
                })}
            </RadioButtonGroup>
        );
    }

    buildCivilResponsabilityDogsInclusion() {
        const options = [
            {
                label: toFirstUppercase(formatText('common-no')),
                value: DOGS_INCLUSION_NO
            },
            {
                label: toFirstUppercase(formatText('common-yes')),
                value: DOGS_INCLUSION_YES
            }
        ];

        const dogsInclusionValue = this.getCoverageValue(DOGS_INCLUSION);

        return (
            <RadioButtonGroup
                className="civil-responsability__radio-group"
                idPrefix="dogsInclusionRadioGroup"
                label={formatText(`${poeditorPrefix}DogsInclusion`)}
                name="dogsInclusionRadioGroup"
                onChange={this.handleRadioButtonChange(DOGS_INCLUSION)}
                selectedValue={dogsInclusionValue}
            >
                {options.map((option, index) => {
                    return (
                        <RadioButton
                            key={`dogs-inclusion-${index}`}
                            label={option.label}
                            value={option.value}
                        />
                    );
                })}
            </RadioButtonGroup>
        );
    }

    buildDogsInclusionInput() {
        const { showDogsInputError } = this.props;

        const dogsInclusionValue = this.getCoverageValue(COVERAGES.DANGEROUS_DOGS_NUMBER);
        const showDogsInput = this.getCoverageValue(DOGS_INCLUSION) === DOGS_INCLUSION_YES;
        const invalidInputValue = showDogsInputError && !dogsInclusionValue;

        return showDogsInput ? (
            <div className="civil-responsability__cr-dogs">
                <OKInput
                    autoComplete={false}
                    label={formatText(`${poeditorPrefix}NumberOfDogs`)}
                    onBlur={this.handleNumberOfDogsBlur}
                    onChange={this.handleNumberOfDogsChange}
                    placeholder={formatText(`${poeditorPrefix}NumberOfDogsPlaceholder`, [MIN, MAX])}
                    value={dogsInclusionValue}
                    errorState={invalidInputValue}
                    errorMessage={formatText(`${poeditorPrefix}DogsInputError`)}
                    textAlignRight
                />
            </div>
        ) : null;
    }

    buildContent() {
        const civilResponsabilityLimit = this.buildCivilResponsabilityLimit();
        const civilResponsabilityDogsInclusion = this.buildCivilResponsabilityDogsInclusion();
        const dogsInclusion = this.buildDogsInclusionInput();

        return (
            <div className="row">
                <div className="col-xs-6">
                    {civilResponsabilityLimit}
                </div>
                <div className="col-xs-6">
                    {civilResponsabilityDogsInclusion}
                    {dogsInclusion}
                </div>
            </div>
        );
    }

    render() {
        const content = this.buildContent();

        return (
            <div className="civil-responsability__container" >
                <h1 className="civil-responsability__title">
                    <FormattedText value={`${poeditorPrefix}CivilResponsability`} /> {this.buildTooltip()}
                </h1>
                {content}
            </div>
        );
    }
}

CivilResponsability.propTypes = {
    immInsuranceWizardStep3: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    showDogsInputError: PropTypes.bool.isRequired,
}

module.exports = CivilResponsability;
